import "./App.css";

import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import TipoA from "./pages/TipoA";
import TipoB from "./pages/TipoB";
import TipoC from "./pages/TipoC";
import Reserva from "./pages/Reserva";
import Contacto from "./pages/Contacto";

/* ===========================
   RUTAS DE APARTAMENTOS
=========================== */

const apartmentRoutes = [
  {
    path: "/apartamentos/tipo-a",
    element: <TipoA />,
  },
  {
    path: "/apartamentos/tipo-b",
    element: <TipoB />,
  },
  {
    path: "/apartamentos/tipo-c",
    element: <TipoC />,
  },
];

/* ===========================
   RUTAS ANTIGUAS
=========================== */

const redirects = [
  {
    from: "/tipo-a",
    to: "/apartamentos/tipo-a",
  },
  {
    from: "/tipo-b",
    to: "/apartamentos/tipo-b",
  },
  {
    from: "/tipo-c",
    to: "/apartamentos/tipo-c",
  },
];

/* ===========================
   ROUTER
=========================== */

function AppRoutes() {
  return (
    <Routes>

      {/* Página Principal */}

      <Route
        path="/"
        element={<Home />}
      />

      {/* Apartamentos */}

      {apartmentRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={route.element}
        />
      ))}

      {/* Reserva */}

      <Route
        path="/reserva"
        element={<Reserva />}
      />

      {/* Contacto */}

      <Route
        path="/contacto"
        element={<Contacto />}
      />

      {/* Compatibilidad */}

      {redirects.map((route) => (
        <Route
          key={route.from}
          path={route.from}
          element={
            <Navigate
              to={route.to}
              replace
            />
          }
        />
      ))}

      {/* Ruta inexistente */}

      <Route
        path="*"
        element={
          <Navigate
            to="/"
            replace
          />
        }
      />

    </Routes>
  );
}

/* ===========================
   APP
=========================== */

function App() {
  return (
    <BrowserRouter>

      {/* Siempre vuelve arriba al cambiar de página */}

      <ScrollToTop />

      {/* Todas las rutas */}

      <AppRoutes />

    </BrowserRouter>
  );
}

export default App;